import React from "react";
import { PaymentCardButtons } from "../paymentCardButtons/PaymentCardButtons";
import { DefaultPaymentCard } from "../defaultPaymentCard/DefaultPaymentCard";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import { usePaymentStore } from "../../stores/StoreContext";
import { EWalletPayment } from "../defaultPaymentCard/EWalletPayment";

type props = {};

export const PaymentOptionsOld: React.FC<props> = () => {
  const paymentStore = usePaymentStore();
  return (
    <div style={{ marginBottom: 30 }}>
      <TCText
        style={{
          fontWeight: 600,
          fontSize: 16,
          color: Colors.green,
          textAlign: "center",
          marginTop: 40,
          marginBottom: 20,
        }}
        value="Payment option"
      />
      {/* <TCText
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: Colors.grey,
          textAlign: "center",
          marginTop: 25,
        }}
        value="Total amount"
      /> */}
      {/* <TCText
        style={{
          fontWeight: 700,
          fontSize: 32,
          color: Colors.green,
          textAlign: "center",
          marginTop: 5,
          marginBottom: 20,
        }}
        value={`${formatAmount(paymentStore.totalAmount)} USD`}
      /> */}
      {paymentStore.isPaymentThroughWallet() && <EWalletPayment />}
      <DefaultPaymentCard />
      <PaymentCardButtons />
    </div>
  );
};
